// extracted by mini-css-extract-plugin
export default {"card":"AppCard_card__JDEZR","clickable":"AppCard_clickable__tr3V6","small":"AppCard_small__ABWeK","active":"AppCard_active__rTck0","disabled":"AppCard_disabled__tCvaa"};